define(['angular', 'moment'], function (angular, moment) {
    'use strict';

    return angular
        .module('textFilters', [])
        .filter('formatdate', [
            function () {
                return function (text, dateOnly) {
                    var date = text;

                    if (!date.format) {
                        date = moment(date);
                    }

                    if (date && date.isValid()) {
                        // Make sure date format matches the format expected on the backend
                        if (dateOnly) {
                            return date.format('M/D/YYYY');
                        } else {
                            return date.format('M/D/YYYY h:mm:ss a');
                        }
                    }
                    return text;
                };
            },
        ])
        .filter('date2save', [
            function () {
                return function (input) {
                    /* Convert date to unix timestamp
                     */
                    if (!input.format) {
                        return input;
                    }

                    return input.format('X');
                };
            },
        ])
        .filter('text2date', [
            function () {
                return function (input) {
                    if (input.format) {
                        // Moment.js instances have a format method
                        return input;
                    }
                    if (!isNaN(input)) {
                        // If numeric, assume it's a timestamp in seconds
                        return moment.unix(input);
                    }
                    if (moment(input).isValid()) {
                        return moment(input);
                    }

                    return null;
                };
            },
        ])
        .filter('striptags', [
            function () {
                return function (input) {
                    if (input) {
                        return input
                            .replace(/<br[^>]+>/gm, ' ')
                            .replace(/<[^>]+>/gm, '')
                            .replace('/\n/', ' ');
                    }

                    return input;
                };
            },
        ]);
});
